// extracted by mini-css-extract-plugin
module.exports = {"svg--small":"styles__svg--small___7hGsA","svg--medium":"styles__svg--medium___io1sf","svg--large":"styles__svg--large___2HJeQ"};